function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * krpano 封装
 * @constructor
 * @param {string} id - 嵌入播放器的 div id
 * @param {Object} krpano - 原始 krpano 播放器对象
 */
var KrpanoHptspotWrapper = /*#__PURE__*/function () {
  function KrpanoHptspotWrapper(id, krpano) {
    _defineProperty(this, "extendData", {});

    this.id = id;
    this.krpano = krpano;
    this.init.bind(this).call();
  }

  var _proto = KrpanoHptspotWrapper.prototype;

  _proto.init = function init() {
    var _properties,
        _this = this;

    var properties = (_properties = {
      'originId': 'originid',
      'type': 'type',
      'url': 'url',
      'keep': 'keep',
      'renderer': 'renderer',
      'visible': 'visible',
      'enabled': 'enabled',
      'handcursor': 'handcursor',
      'cursor': 'cursor',
      'maskChildren': 'maskchildren',
      'zOrder': 'zorder',
      'capture': 'capture',
      'children': 'children',
      'blendMode': 'blendmode',
      'alphaChannel': 'alphachannel',
      'chromakey': 'chromakey',
      'mipmapping': 'mipmapping',
      'premultiplyAlpha': 'premultiplyalpha',
      'style': 'style',
      'ath': 'ath',
      'atv': 'atv',
      'edge': 'edge',
      'ox': 'ox',
      'oy': 'oy',
      'oref': 'oref',
      'zoom': 'zoom',
      'distorted': 'distorted',
      'rotationOrder': 'rotationorder',
      'rx': 'rx',
      'ry': 'ry',
      'rz': 'rz',
      'inverseRotation': 'inverserotation',
      'depth': 'depth',
      'depthBuffer': 'depthbuffer',
      'tOrigin': 'torigin',
      'tX': 'tx',
      'tY': 'ty',
      'tZ': 'tz',
      'prealign': 'prealign',
      'flying': 'flying',
      'scaleFlying': 'scaleflying',
      'width': 'width',
      'height': 'height',
      'scale': 'scale',
      'scaleX': 'scalex',
      'loaded': 'loaded',
      'scaleY': 'scaley',
      'rotate': 'rotate',
      'pixelHitTest': 'pixelhittest',
      'accuracy': 'accuracy',
      'alpha': 'alpha',
      'autoAlpha': 'autoalpha',
      'useContentSize': 'usecontentsize',
      'scale9Grid': 'scale9grid',
      'stereo': 'stereo',
      'crop': 'crop',
      'onOverCrop': 'onovercrop',
      'onDownCrop': 'ondowncrop',
      'scaleChildren': 'scalechildren',
      'onClick': 'onclick',
      'onLoaded': 'onloaded',
      'fillColor': 'fillcolor',
      'fillAlpha': 'fillalpha',
      'borderWidth': 'borderwidth',
      'borderColor': 'bordercolor',
      'borderAlpha': 'borderalpha',
      'normalFillColor': 'normalfillcolor',
      'normalFillAlpha': 'normalfillalpha',
      'normalBorderWidth': 'normalborderwidth',
      'normalBorderColor': 'normalbordercolor',
      'normalBorderAlpha': 'normalborderalpha',
      'overFillColor': 'overfillcolor',
      'overFillAlpha': 'overfillalpha',
      'overBorderWidth': 'overborderwidth',
      'overBorderColor': 'overbordercolor',
      'overBorderAlpha': 'overborderalpha',
      'borderZoom': 'borderzoom',
      'borderHitTest': 'borderhittest',
      'subDiv': 'subdiv',
      'html': 'html',
      'css': 'css',
      'vCenter': 'vcenter',
      'padding': 'padding',
      'wordwrap': 'wordwrap',
      'bg': 'bg',
      'bgColor': 'bgcolor',
      'bgAlpha': 'bgalpha',
      'bgBorder': 'bgborder',
      'bgRoundedge': 'bgroundedge',
      'bgShadow': 'bgshadow',
      'txtShadow': 'txtshadow',
      'mergedAlpha': 'mergedalpha',
      'overSampling': 'oversampling',
      'bgImage': 'bgimage',
      'frame': 'frame',
      'latestFrame': 'latestframe',
      'frameWidth': 'framewidth',
      'frameHeight': 'frameheight',
      'frameCount': 'framecount',
      'frameDuration': 'frameDuration',
      'extendImage': 'extendimage',
      'videoUrl': 'videourl',
      'posterUrl': 'posterurl',
      'loop': 'loop',
      'muted': 'muted',
      'pausedOnStart': "pausedonstart",
      'onVideoReady': 'onvideoready',
      'onVideoPlay': 'onvideoplay',
      'onVideoPaused': 'onvideopaused',
      'onVideoComplete': 'onvideocomplete',
      'onError': 'onerror',
      'hFov': 'hfov',
      'yaw': 'yaw',
      'pitch': 'pitch',
      'roll': 'roll',
      'titleHotspotId': 'titlehotspotid',
      'hotspotId': 'hotspotid',
      'pointId': 'pointid',
      'points': 'points',
      'autoPlayType': 'autoplaytype',
      'autoPlayDuration': 'autoplayduration',
      'urls': 'urls',
      'fontSize': 'fontsize',
      'fontColor': 'fontcolor',
      'fontFamily': 'fontfamily',
      'align': 'align',
      'borderImageId': 'borderImageId',
      'extendImageUrl': 'extendimageurl',
      'extendImageWidth': 'extendimagewidth',
      'extendImageLength': 'extendimagelength',
      'iconImage': 'iconImage',
      'dragable': 'dragable',
      'volume': 'volume',
      'autoPause': 'autopause',
      'autoResume': 'autoresume',
      'html5Preload': 'html5preload',
      'blink': 'blink',
      'blinkDuration': 'blink_duration',
      'autoResize': 'autoresize'
    }, _properties["vCenter"] = 'vcenter', _properties['isLine'] = 'isline', _properties['endPointMode'] = 'endpointmode', _properties['polyline'] = 'polyline', _properties['isDiv'] = 'isdiv', _properties['isComment'] = 'iscomment', _properties['clickTargetId'] = 'clicktargetid', _properties['captureFocus'] = 'capturefocus', _properties);
    var krpano = this.krpano;
    this.properties = {};

    for (var key in properties) {
      if (properties.hasOwnProperty(key)) {
        (function () {
          var property = properties[key];
          Object.defineProperty(_this, key, {
            get: function get() {
              if (property == 'points' && krpano.get('hotspot[' + this.id + '].point')) {
                return krpano.get('hotspot[' + this.id + '].point').getArray();
              }

              return krpano.get('hotspot[' + this.id + '].' + property);
            },
            set: function set(value) {
              if (value === undefined || value === null) {
                krpano.set('hotspot[' + this.id + '].' + property, null);
                return;
              }

              krpano.set('hotspot[' + this.id + '].' + property, value);
            }
          });
        })();
      }
    }

    ;
    var eventsProperties = {
      'onOver': 'onover',
      'onHover': 'onhover',
      'onOut': 'onout',
      'onDown': 'ondown',
      'onUp': 'onup',
      'onClick': 'onclick',
      'onLoaded': 'onloaded'
    };
    var eventsKey = 'events';
    this[eventsKey] = {
      __playerId: this.krpano.id,
      __id: this.id,
      __callbacks: {}
    };
    var krpano = this.krpano;

    var _loop = function _loop(_key) {
      if (eventsProperties.hasOwnProperty(_key)) {
        var property = eventsProperties[_key];
        Object.defineProperty(_this[eventsKey], _key, {
          get: function get() {
            return this.__callbacks[_key];
          },
          set: function set(value) {
            if (value === undefined || value === null) {
              krpano.set(eventsKey + '.' + property, null);
              return;
            }

            if (_key == 'onClick') {
              krpano.set('hotspot[' + this.__id + ']' + '.' + property, 'if(webvr.isenabled != true,jscall(event.preventDefault();event.stopPropagation();););jscall(window.patch_wait_hotspot_click = true;setTimeout(function(){window.patch_wait_hotspot_click = false;}, 500); window.players[\'' + this.__playerId + '\'].getHotspotById("' + this.__id + '").events.' + _key + '({id:"' + this.__id + '"});)');
            } else {
              krpano.set('hotspot[' + this.__id + ']' + '.' + property, 'jscall(window.players[\'' + this.__playerId + '\'].getHotspotById("' + this.__id + '").events.' + _key + '({id:"' + this.__id + '"});)');
            }

            this.__callbacks[_key] = value;
          }
        });
      }
    };

    for (var _key in eventsProperties) {
      _loop(_key);
    }
  };

  /**
   * 为热点添加附加属性
   * @param {string} key - key
   * @param {any} value - value
   */
  _proto.addExtendData = function addExtendData(key, value) {
    this.extendData[key] = value;
  }
  /**
   * 获取热点附加属性
   * @param {string} key - key
   */
  ;

  _proto.getExtendData = function getExtendData(key) {
    return this.extendData[key];
  };

  return KrpanoHptspotWrapper;
}();

export { KrpanoHptspotWrapper as default };